import {
	NgModule,
	Optional,
	SkipSelf
} from '@angular/core';

import {
	BrowserModule
} from '@angular/platform-browser';

import {
	BrowserAnimationsModule
} from '@angular/platform-browser/animations';

import {
	RouterModule
} from '@angular/router';

import {
	HTTP_INTERCEPTORS
} from '@angular/common/http';

import {
	Dd1pndsContenuEditoService,
	Dd1pndsNgRedirectionService,
	Dd1pndsNgSessionManagerService,
	Dd1pndsNgStatistiquesService,
	HttpReponseAuthService,
	HttpResponseErrorInterceptorService,
	HttpReponseParamsSiteService
} from 'dd1pnds-ngx-services';

import {
	VariablesGlobales
} from './../../configs/app.config';

const importModules = [
	BrowserModule,
	BrowserAnimationsModule,
	RouterModule
];

const exportModules = [
	BrowserModule,
	BrowserAnimationsModule
];

const providers = [
	{
		provide: HTTP_INTERCEPTORS, useClass: HttpResponseErrorInterceptorService, multi: true
	},
	HttpReponseAuthService,
	HttpReponseParamsSiteService,
	Dd1pndsContenuEditoService,
	VariablesGlobales,
	Dd1pndsNgRedirectionService,
	Dd1pndsNgSessionManagerService,
	Dd1pndsNgStatistiquesService
];

@NgModule({
	imports: [...importModules],
	exports: [...exportModules],
	providers: [...providers]
})

export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule has already been loaded. Import Core modules in the AppModule only.');
		}
	}
}
